// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrderGroupDetails_wrapper__3Qu4F","open":"OrderGroupDetails_open__35nSy","buyer-name":"OrderGroupDetails_buyer-name__1JBRP"};